import "./Header.css";
import {
  NavDropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import UserCartMenuItem from "./UserCartMenuItem";

export default function UserNavMenu(props) {
// user's dropdown menu (used in the header) with links to the corresponding subpages

    return (
        <>
        <NavDropdown.Item
          eventKey="/user"
          as={Link}
          to="/user"
          className="navbar-collapsed-menu-button"
          onClick={props?.toggleNavExpansion}

        >
          My Profile
        </NavDropdown.Item>
        <NavDropdown.Item
          eventKey="/user/my-orders" //highlight blue if == current page
          as={Link}
          to="/user/my-orders"
          className="admin-navbar-dropdown-item navbar-collapsed-menu-button"
          onClick={props?.toggleNavExpansion}
        >
          My Orders
        </NavDropdown.Item>
        <NavDropdown.Item
          eventKey="/user/my-reviews" //highlight blue if == current page
          as={Link}
          to="/user/my-reviews"
          className="admin-navbar-dropdown-item navbar-collapsed-menu-button"
          onClick={props?.toggleNavExpansion}
        >
          My Reviews
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => {
            props.logout(); 
            props?.toggleNavExpansion?.()}}
          className="navbar-collapsed-menu-button"
        >
          Logout
        </NavDropdown.Item>
        <NavDropdown.Item className="navbar-collapsed-menu-button navbar-admin-menu-small-screen">
        <UserCartMenuItem quantity={props.quantity} toggleNavExpansion={props?.toggleNavExpansion}/>
        </NavDropdown.Item>
      </>
          );
    
}